export enum CouponStatus {
  READY = 'READY',
  USED = 'USED'
}
